angular.module('dialogs')
    .controller('DrawApprovalDialogCtrl',
        [
            '$scope', '$modalInstance', '$routeParams', 'GameFactory',
            function ($scope, $modalInstance, $routeParams, gameFactory) {

                init();

                function init() {
                    gameFactory.GetdrawApprovalDetails($routeParams.gameId)
                        .success(function (drawApproval) {
                            $scope.DrawApproval = drawApproval;
                        })
                        .error(function (error) {
                            $.message(error.ExceptionMessage, MessageType.Error);
                        });
                };

                $scope.SiSTechApprove = function () {
                    gameFactory.SiSTechApprove($routeParams.gameId)
                        .success(function (result) {
                            $scope.DrawApproval.SisApproved = result;

                        })
                        .error(function (error) {
                            $.message(error.ExceptionMessage, MessageType.Error);
                        });
                };

                $scope.AdjudicatorApprove = function () {
                    gameFactory.AdjudicatorApprove($routeParams.gameId)
                        .success(function (result) {
                            $scope.DrawApproval.AdjudicatorApproved = result;
                        })
                        .error(function (error) {
                            $.message(error.ExceptionMessage, MessageType.Error);
                        });
                };

                $scope.no = function () {
                    $modalInstance.dismiss('no');
                };

                $scope.yes = function () {
                    $modalInstance.close('yes');
                };
            }
        ]);